module.exports = __webpack_public_path__ + "img/3-3.681149f5.svg";